import React from "react";
import "./UaeAbout.css";
import uae from "./../../../../vid_img/uaeAbout.jpg"
const UaeAboutMain = () => {
  return (
    <div className="uaeAboutUsMainContainer">
      <div className="uaeAboutUsMainContent">
        <ul>
          <li>
            The United Arab Emirates, a confederation of seven Emirates, is fast
            emerging as a major economic and business zone in the Middle-East.
            With a future-oriented economy, the UAE is stands 26th in the list
            of best nations in the world to do business.
          </li>
          <li>
            Many Indians have worked and settled there. Goodway Attestation
            assists in quick processing of visa applications of Indians
            travelling to the UAE either for work, tour or immigration.
            Residents of Bengaluru need not look beyond Goodway Attestation to
            get certificates and documents attestation services for UAE in
            Bengaluru.
          </li>
          <li>
            You can trust the professionals at Goodway Attestation to guide you
            through the necessary paperwork and attestation for UAE in
            Bengaluru. They are knowledgeable about the terms and conditions
            that visitors and workers have to abide by, during their stay in the
            UAE.
          </li>
          <li>
            Bring all your important certificates for attestation for UAE in
            Bengaluru, itself, at Goodway Attestation. They can be educational,
            experience, medical or other important certificates. This will
            surely make your UAE travel hassle-free.
          </li>
          <li>
            Certain important certificates and documents need UAE embassy
            attestation. No worries, you can get your papers attested in
            Bengaluru itself, through our resourceful and friendly professionals
            at Goodway Attestation. You can focus on other related important
            tasks.
          </li>
          <li></li>
        </ul>
      </div>
      <div className="uaeAboutUsMainContentImg">
        <img
          src={uae}
          alt="uae"
        />
      </div>
    </div>
  );
};

export default UaeAboutMain;
